import { DetailsHeader, DetailsListLayoutMode, Selection, IColumn, Icon, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IRenderFunction, Link, ProgressIndicator, SelectionMode, ShimmeredDetailsList, Stack, useTheme, IconButton, CommandButton, IContextualMenuProps } from '@fluentui/react';
import * as React from 'react';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';

interface IInvoiceItemListViewProps {
    items: IInvoiceItem[];
    selectedItem?: IInvoiceItem;
    selectItem: (item?: IInvoiceItem) => void;
    isReadOnly: boolean;
    isLoading: boolean;
    newItem: () => void;
    addRegistration: () => void;
    updateItem: (item:IInvoiceItem) => void;
    deleteItem: () => void;
}


export const InvoiceItemListView: React.FunctionComponent<IInvoiceItemListViewProps> = (props) => {

    const [selected, setSelected] = React.useState<IInvoiceItem[]>([]);
    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IInvoiceItem[];
            setSelected(selected);
        },
    }));
    const [addItemDialogOpen, setAddItemDialogOpen] = React.useState(false);
    const [addRegistrationDialogOpen, setAddRegistrationDialogOpen] = React.useState(false);

    React.useEffect(() => {
        if (selected.length > 0) {
            props.selectItem(selected[0]);
        }
        else {
            props.selectItem(undefined);
        }
    }, [selected])

    const theme = useTheme();
    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,

        }
    }

    const headerStyleRight: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,

        },
        cellTitle: {
            justifyContent: 'end'
        }
    }


    const _columns: IColumn[] = [
        { key: 'itemId', name: 'Id', fieldName: 'itemId', minWidth: 50, maxWidth: 50, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'itemName', name: 'Název', fieldName: 'itemName', minWidth: 80, maxWidth: 240, isResizable: true, isCollapsible: false, styles: headerStyle },        
        { key: 'amount', name: 'Množství', fieldName: 'amount', minWidth: 60, maxWidth: 120, isResizable: true, styles: headerStyleRight },
        { key: 'price', name: 'Cena/ks', fieldName: 'price', minWidth: 60, maxWidth: 120, isResizable: true, isCollapsible: true, styles: headerStyleRight },
        { key: 'total', name: 'Celkem', fieldName: 'total', minWidth: 60, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'totalWithVat', name: 'Celkem s DPH', fieldName: 'totalWithVat', minWidth: 60, maxWidth: 100, isResizable: true, isCollapsible: true, styles: headerStyle },        
    ];

    const formatPrice = (value?: number) => {
        return value?.toFixed(2);
    }

    const renderItemColumn = (item: IInvoiceItem, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IInvoiceItem];
            switch (column.key) {
                case "itemId":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}><Link onClick={() => props.updateItem(item)}>{fieldContent?.toString()}</Link></span>
                case "amount":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end', }}>{formatPrice(fieldContent as number)}</span>
                case 'price':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>{formatPrice(fieldContent as number)}</span>
                case 'total':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>{formatPrice(fieldContent as number)}</span>
                case 'totalWithVat':
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>{formatPrice(fieldContent as number)}</span>
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent?.toString()}</span>
            }
        }
        else {
            return (<div></div>)
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }

    const menuProps: IContextualMenuProps = {
        // For example: disable dismiss if shift key is held down while dismissing
        onDismiss: ev => {
            if (ev && 'shiftKey' in ev) {
                ev.preventDefault();
            }
        },
        items: [
            {
                key: 'line',
                text: 'Přidat řádek',
                onClick: props.newItem
                
            },
            {
                key: 'registration',
                text: 'Přidat registraci',
                onClick: props.addRegistration
            },
        ],
        directionalHintFixed: true,
    };

    return (<Stack styles={{ root: { paddingTop: 20 } }}>

        <Stack horizontal>
            <CommandButton disabled={props.isReadOnly} menuProps={menuProps} iconProps={{ iconName: "add" }} text="Přidat položku" />
            <CommandButton disabled={props.selectedItem === undefined || props.isReadOnly} iconProps={{ iconName: "Delete" }} text="Odstranit vybrané" onClick={props.deleteItem} />
        </Stack>

        <Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>

        <ShimmeredDetailsList
            items={props.items}
            columns={_columns}
            setKey="set"
            onRenderDetailsHeader={onRenderDetailsHeader}
            selectionMode={SelectionMode.single}
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={renderItemColumn}
            selection={selectionState}
            selectionPreservedOnEmptyClick={false}
            ariaLabelForSelectionColumn="Výběr věkové skupiny"
            ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
            checkButtonAriaLabel="Vyber řádek"
            onItemInvoked={(item: IInvoiceItem) => props.selectItem(item)}
        />

    </Stack>)
}
 